export default __webpack_public_path__ + "static/media/Fruits.9e3315e1.jpg";